export const hotelSpokenLanguages = {
  ja: "Japanese",
};
